// extracted by mini-css-extract-plugin
export default {"all_commission":"styles_all_commission__Tax7x","commission":"styles_commission__53vcX","init":"styles_init__QHl6S","grey_text":"styles_grey_text__3FsBu","text":"styles_text__qHXO5"};